import {usePlantConfig} from '@domain/shifthandover'
import {getQuickSelectFilter, getUrlParam} from '@hconnect/common/utils'
import {useUpmPlantTimezone} from '@hconnect/upm'
import moment, {Moment} from 'moment-timezone'
import {useMemo} from 'react'
import {useSearchParams} from 'react-router'

type Props = {
  key: string
  defaultTimeRange: string
  plantId: string
}

export const useOptimizationSpecialistPlantTimeRange = ({
  key,
  defaultTimeRange,
  plantId
}: Props): {
  from?: Moment
  to?: Moment
  hasShifts: boolean
  isLoading: boolean
} => {
  // Note: Only shifts are used from the plantConfig here.
  // If a refresh based on language is required,
  // pass the selected language down here from i18next
  const {data: config, isLoading: isInitialLoading} = usePlantConfig({plantId, language: 'en-US'})
  const timezone = useUpmPlantTimezone(plantId)
  const [searchParams] = useSearchParams()
  const timeRangeParam = getUrlParam(searchParams, key) ?? defaultTimeRange
  const hasShifts = !!config?.shifts.length

  const timeRange = useMemo(() => {
    if (hasShifts) {
      const now = moment().tz(timezone)
      const [startDate, endDate] = getQuickSelectFilter(timeRangeParam, config.shifts, now)

      return {
        from: startDate,
        to: endDate
      }
    }
  }, [config, timezone, timeRangeParam, hasShifts])

  return {
    ...timeRange,
    hasShifts,
    isLoading: isInitialLoading
  }
}
